// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, .cvx-header-container .cvx-header-menu .cvx-header-menu-item a span, .cvx-header-container .cvx-header-application span {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

.cvx-header-container {
  display: grid;
  grid-template-columns: 400px auto 400px;
  grid-auto-flow: column;
  height: 100%;
  background-color: #ffffff;
}
.cvx-header-container .cvx-header-menu {
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  padding-left: 1rem;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 40px;
  text-decoration: none;
  height: 40px;
  border-radius: 13px;
  padding-left: 0px;
  padding-right: 0px;
  min-width: 50px;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a ::ng-deep .mdc-button__label {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a i {
  font-size: 1.375rem;
  font-weight: 900;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a span {
  margin-top: 2px;
  font-size: 0.75rem;
}
.cvx-header-container .cvx-header-application {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.cvx-header-container .cvx-header-application img {
  width: 3.2rem;
  cursor: pointer;
}
.cvx-header-container .cvx-header-application span {
  margin-top: 0.5rem;
  color: #009dd9;
  font-size: 1.375rem;
  cursor: default;
}
.cvx-header-container .cvx-header-profile {
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  padding-left: 1rem;
  padding-right: 1rem;
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/app/shared/components/cvx-header/cvx-header.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAQA;EACE,yBAAA;EACA,iEAAA;EACA,iBAPO;EAQP,gBARO;ACCT;ADUA;EACE,+BAAA;EACA,0EAAA;EACA,iBAdO;EAeP,gBAfO;ACOT;ADWA;EACE,4CAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,8CAAA;ACTF;;ADaA,YAAA;AACA;EACE,kBAxCW;EAyCX,OAAA;ACVF;;ADaA;EACE,mBA5CO;EA6CP,OAAA;ACVF;;ADaA;EACE,mBAhDM;EAiDN,OAAA;ACVF;;ADaA;EACE,eApDO;EAqDP,OAAA;ACVF;;ADaA;EACE,mBAxDO;EAyDP,OAAA;ACVF;;ADaA;EACE,kBA5DM;EA6DN,OAAA;ACVF;;AAtDA;EACI,aAAA;EACA,uCAAA;EACA,sBAAA;EACA,YAAA;EACA,yBCoBI;ADqCR;AAvDI;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAyDR;AAtDY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAwDhB;AArDgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAuDpB;AApDgB;EACI,mBDrCX;ECsCW,gBAAA;AAsDpB;AAnDgB;EAEI,eAAA;EACA,kBDxCZ;AC4FR;AA9CI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAgDR;AA9CQ;EACI,aAAA;EACA,eAAA;AAgDZ;AA7CQ;EAEI,kBAAA;EACA,cChEC;EDiED,mBDjEH;ECkEG,eAAA;AA8CZ;AA1CI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AA4CR","sourcesContent":["// FONTS\n$extraLarge: 1.75rem; // 28pt\n$large2: 1.375rem; // 22pt\n$large: 1.125rem; // 18pt\n$normal: 1rem; // 16pt\n$medium: 0.875rem; // 14pt\n$small: 0.75rem; // 12pt\n\n@font-face {\n  font-family: \"GothamBold\";\n  src: url(\"/fonts/gothambold_normal_normal.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n@font-face {\n  font-family: \"GothamNarrowBook\";\n  src: url(\"/fonts/GothamNarrowBook_normal_condensed.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n.cvx-font-gotham-bold {\n  font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.cvx-fon-narrow-bold {\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n}\n\n.cvx-font-gotham-narrow-book {\n  font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.cvx-gothan-medium {\n  font-family: \"GothamMedium\", Arial, sans-serif;\n}\n\n\n/*font-szes*/\n.extraLarge {\n  font-size: $extraLarge;\n  /*28px*/\n}\n\n.large2 {\n  font-size: $large2;\n  /*22px*/\n}\n\n.large {\n  font-size: $large;\n  /*18px*/\n}\n\n.normal {\n  font-size: $normal;\n  /*16px*/\n}\n\n.medium {\n  font-size: $medium;\n  /*14px*/\n}\n\n.small {\n  font-size: $small;\n  /*12px*/\n}","@use '../../../../styles/fonts.scss' as fonts;\n@use '../../../../styles/colors.scss' as colors;\n\n.cvx-header-container {\n    display: grid;\n    grid-template-columns: 400px auto 400px;\n    grid-auto-flow: column;\n    height: 100%;\n    background-color: colors.$white;\n\n    .cvx-header-menu {\n        display: flex;\n        justify-content: center;\n        align-items: start;\n        flex-direction: column;\n        padding-left: 1rem;\n\n        .cvx-header-menu-item {\n            a {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                flex-direction: column;\n                width: 40px;\n                text-decoration: none;\n                height: 40px;\n                border-radius: 13px;\n                padding-left: 0px;\n                padding-right: 0px;\n                min-width: 50px;\n\n                // ::ng-deep: \n                ::ng-deep .mdc-button__label {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                }\n\n                i {\n                    font-size: fonts.$large2;\n                    font-weight: 900;\n                }\n\n                span {\n                    @extend .cvx-font-gotham-bold;\n                    margin-top: 2px;\n                    font-size: fonts.$small;\n                }\n            }\n        }\n    }\n\n    .cvx-header-application {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n\n        img {\n            width:  3.2rem; //43px\n            cursor: pointer;\n        }\n\n        span {\n            @extend .cvx-font-gotham-bold;\n            margin-top: 0.5rem;\n            color: colors.$light-blue;\n            font-size: fonts.$large2;\n            cursor: default;\n        }\n    }\n\n    .cvx-header-profile {\n        display: flex;\n        justify-content: center;\n        align-items: end;\n        flex-direction: column;\n        padding-left: 1rem;\n        padding-right: 1rem;\n        float: right;\n    }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
